import { render, staticRenderFns } from "./LaudoHistoricoAgricola.vue?vue&type=template&id=04ed7b8e&scoped=true&lang=pug"
import script from "./LaudoHistoricoAgricola.vue?vue&type=script&lang=js"
export * from "./LaudoHistoricoAgricola.vue?vue&type=script&lang=js"
import style0 from "./LaudoHistoricoAgricola.vue?vue&type=style&index=0&id=04ed7b8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed7b8e",
  null
  
)

export default component.exports